import { useEffect, useState } from "react";
import styles from "./Candidates.module.css";
import { SORTING_OPTIONS } from "../../../../../constant";
import DataTableWithFilters from "../../../../CommonComponents/DataTableWithFilters";
import ActionMenu from "../../../../CommonComponents/ActionMenu";
import { ENTERPRISE_COMPANY } from "../../../../../urlConfig";
import { useNavigate } from "react-router-dom";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import useNotification from "../../../../../hooks/useNotification";
import userAvatar from "../../../../../assets/userAvatar-Other.png";
import moment from "moment";
import { Button, Checkbox } from "antd";
import { CiLock } from "react-icons/ci";
import { FaRegCircleCheck } from "react-icons/fa6";
import RequestScoreModal from "./RequestScoreModal";

const Candidates = (props) => {
  const navigate = useNavigate();
  const [selectedSort, setSelectedSort] = useState(["Most Recent"]);
  const [searchInput, setSearchInput] = useState("");
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState();
  const [prevPage, setPrevPage] = useState();
  const [total, setTotal] = useState(100);
  const [selectedTab, setSelectedTab] = useState("Candidates");
  const [showRequestScoreModal, setShowRequestScoreModal] = useState(false);
  const [selectedAtsCandidates, setSelectedAtsCandidates] = useState([]);

  const handleCheckboxChange = (item) => {
    if (selectedAtsCandidates.includes(item)) {
      setSelectedAtsCandidates(
        selectedAtsCandidates.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      setSelectedAtsCandidates([...selectedAtsCandidates, item]);
    }
  };

  const jobData = props.data;

  const fetchUserOverviewData = async (nextPage, prevPage) => {
    setLoading(true);
    try {
      let queryParams = [`pageSize=10`];

      if (nextPage) queryParams.push(`nextPage=${nextPage}`);
      if (prevPage) queryParams.push(`prevPage=${prevPage}`);
      if (searchInput) queryParams.push(`search=${searchInput}`);
      if (selectedTab) queryParams.push(`tab=${selectedTab}`);

      let str = queryParams.join("&");

      const res = await EnterpriseServices.getJobCandidatesById(
        jobData._id + "?" + str
      );

      if (res) {
        if (res.statusCode === 1) {
          setData(res.data);
          setTotal(res.total);
          setNextPage(res.nextPage);
          setPrevPage(res.prevPage);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating info", error);
        handleError(error.description);
      } else {
        handleError("Error: Member info is not updated.");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (jobData?._id) {
      fetchUserOverviewData();
    }
  }, [jobData?._id]);

  const handleDelete = (id) => {
    console.warn("delete clicked", id);
  };

  const handleClick = (record) => {
    navigate(ENTERPRISE_COMPANY + record.key);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleTabChange = (value) => {
    setSelectedTab(value);
  };

  const handleSearch = (value) => {
    setSearchInput(value);
  };

  const handlePageChange = (isNextPage) => {
    if (isNextPage) {
      fetchUserOverviewData(nextPage, "", false);
    } else {
      fetchUserOverviewData("", prevPage, true);
    }
  };

  const requestIndexScore = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, [searchInput, selectedTab]);

  const handleButtonClick = () => {
    setShowRequestScoreModal(true);
  };

  const columns = [
    {
      title: `Candidates (${data.length})`,
      dataIndex: "candidateName",
      key: "candidateName",
      minWidth: 200,
      render: (name, record) => {
        return (
          <div
            className={styles.user_image_wrap}
            // onClick={() => handleClick(record)}
          >
            <img
              src={
                record?.candidateData?.profileImage?.docs
                  ? record?.candidateData?.profileImage?.docs
                  : userAvatar
              }
              alt="user avatar"
            />
            {name}
          </div>
        );
      },
    },
    {
      title: "Relevence",
      dataIndex: "relevence",
      key: "relevence",
      sorter: (a, b) => a.relevence - b.relevence,
      render: (relevence, record) => {
        return (
          <div>{Object.values(record?.relevanceScore)?.[0]?.toFixed(2)}%</div>
        );
      },
    },
    {
      title: "IndexScore",
      dataIndex: "indexScore",
      key: "indexScore",
      minWidth: 130,
      sorter: (a, b) => a?.indexScore.localeCompare(b?.indexScore),
      render: (indexScore, record) => {
        let paidForKyc = false;
        if (record.candidateData?.indexscores_payments) {
          let payments = record.candidateData?.indexscores_payments;
          for (let i = 0; i < payments.length; i++) {
            const element = payments[i];
            if (element.enterpriseId === record?.enterpriseData?._id) {
              paidForKyc = true;
            }
          }
        }
        return (
          <div>
            {record.score ? (
              paidForKyc && record.kycVerification ? (
                <div
                  className={indexScore > 500 ? styles.badge_1 : styles.badge_2}
                >
                  {indexScore}
                </div>
              ) : (
                <Checkbox
                  checked={true}
                  disabled={true}
                  className={styles.checkbox_wrap}
                >
                  Requested
                </Checkbox>
              )
            ) : (
              <Checkbox
                disabled={true}
                checked={selectedAtsCandidates.includes(record)}
                onChange={() => handleCheckboxChange(record)}
                className={styles.checkbox_wrap}
              >
                Request
              </Checkbox>
            )}
          </div>
        );
      },
    },
    {
      title: "Verified",
      dataIndex: "kycVerification",
      key: "kycVerification",
      minWidth: 130,
      sorter: (a, b) => a.verified.localeCompare(b.verified),
      render: (verified, record) => {
        let paidForKyc = false;
        if (record.candidateData?.indexscores_payments) {
          let payments = record.candidateData?.indexscores_payments;
          for (let i = 0; i < payments.length; i++) {
            const element = payments[i];
            if (element.enterpriseId === record?.enterpriseData?._id) {
              paidForKyc = true;
            }
          }
        }

        const isVerified = record.score
          ? paidForKyc && record.kycVerification
            ? "high"
            : "pending"
          : "pending";
        return isVerified === "pending" ? (
          "Pending"
        ) : (
          <div className={styles.verified_cell}>{<FaRegCircleCheck />}</div>
        ); // just for decoration
      },
    },
    {
      title: "purpose",
      dataIndex: "purpose",
      key: "purpose",
      minWidth: 130,
      sorter: (a, b) => a.purpose.localeCompare(b.purpose),
      render: (purpose, record) => {
        let paidForKyc = false;
        if (record.candidateData?.indexscores_payments) {
          let payments = record.candidateData?.indexscores_payments;
          for (let i = 0; i < payments.length; i++) {
            const element = payments[i];
            if (element.enterpriseId === record?.enterpriseData?._id) {
              paidForKyc = true;
            }
          }
        }

        const score = record.score
          ? paidForKyc && record.kycVerification
            ? Math.round(record.culturefit?.[record.company_Name]) + "%"
            : "Pending"
          : "Pending";
        return (
          <div className={styles.purpose_cell}>
            {score ? score : <CiLock />}
          </div>
        ); // just for decoration
      },
    },
    {
      title: "Location",
      dataIndex: "country",
      key: "country",
      minWidth: 130,
      sorter: (a, b) => a.country.localeCompare(b.country),
      render: (country, record) => {
        return (
          <div className={styles.location_cell}>
            {country || "United States"}
          </div>
        ); // just for decoration
      },
    },
    // {
    //   title: "",
    //   dataIndex: "Actions",
    //   key: "Actions",
    //   minWidth: 10,
    //   maxWidth: 15,
    //   render: (status, record) => {
    //     return (
    //       <div>
    //         <ActionMenu
    //           options={[
    //             {
    //               label: "Edit",
    //               route: ENTERPRISE_COMPANY + record.key,
    //             },
    //             {
    //               label: "Delete",
    //               action: () => handleDelete(record),
    //             },
    //           ]}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  const handleSortChange = (value) => {
    setSelectedSort(value);
  };

  const handleFilterChange = (value) => {};
  const buttonGroup = () => {
    return (
      <>
        <Button type="primary" onClick={handleButtonClick}>
          Request Score
        </Button>
      </>
    );
  };

  const handleCancel = (value) => {
    setShowRequestScoreModal(value);
  };

  const handleSubmit = () => {
    fetchUserOverviewData();
  };

  return (
    <div className={styles.content_wrap}>
      <DataTableWithFilters
        columns={columns}
        data={data}
        sortOptions={SORTING_OPTIONS}
        handleFilterChange={handleFilterChange}
        handleSortChange={handleSortChange}
        selectedSort={selectedSort}
        tableKey={"key"}
        selectedTab={selectedTab}
        onTabChange={handleTabChange}
        pageSize={10}
        loading={loading}
        radioTabOptions={[
          { lable: "Candidates", value: "Candidates" },
          { lable: "Favourites", value: "Favourites" },
          { lable: "Rejected", value: "Rejected" },
        ]}
        total={total}
        hideSearch={true}
        handlePageChange={handlePageChange}
        scroll={{
          x: "max-content",
        }}
        // buttonComponent={buttonGroup}
      />
      <RequestScoreModal
        isOpen={showRequestScoreModal}
        data={selectedAtsCandidates}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default Candidates;
